import CallToActionBasicBlock from 'libs/wordpress/content/cmsBlocks/CallToActionBasicBlock';
import MaxWidthWrapper from 'components/wrappers/MaxWidthWrapper';
import PropTypes from 'prop-types';
import React from 'react';
import colors from 'config/theme/colors';
import moduleMargins from 'config/theme/moduleMargins';
import { moduleSettingsProp } from 'utils/proptypes/modules/settingsProps';

const CallToActionBasicModule = ({ last = false, settings = {}, ...rest }) => {
    const { background_color: backgroundColor, text_color: textColor } = settings;

    return (
        <MaxWidthWrapper
            includeContentMargins
            as="section"
            backgroundColor={backgroundColor}
            borderBottom={!last ? `1px solid ${colors.black}` : null}
            py={moduleMargins.md}
        >
            <CallToActionBasicBlock headingSize="lg" moduleTextColor={textColor} {...rest} />
        </MaxWidthWrapper>
    );
};

CallToActionBasicModule.propTypes = {
    last: PropTypes.bool,
    settings: moduleSettingsProp,
};

export default CallToActionBasicModule;
